var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_c('form',{ref:"form",attrs:{"action":_vm.url,"method":_vm.Meth,"id":"form","target":"if"}}),_c('iframe',{ref:"iframe",attrs:{"name":"if","src":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }